import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { findByType } from "../util/findByType";
import { Icon } from "../../components/Icons";
import * as styles from "./List.module.scss";

const Item = () => null;
Item.displayName = "ListItem";

const List = ({ children, className, variant, listStyle }) => {
	// eslint-disable-next-line no-console
	const renderItems = () =>
		React.Children.map(children, i => {
			const item = findByType(i, Item);
			if (!item) {
				return null;
			}
			return (
				<li className={item.props.className} style={item.props.style}>
					{listStyle === "icons" && <Icon name="checked--o" />}
					{item.props.children}
				</li>
			);
		});
	return (
		<>
			{variant === "unordered" ? (
				<ul
					className={cx(styles.list, {
						[styles[listStyle]]: listStyle,
						[className]: className,
					})}>
					{renderItems()}
				</ul>
			) : (
				<ol
					className={cx(styles.list, {
						[className]: className,
					})}>
					{renderItems()}
				</ol>
			)}
		</>
	);
};

List.Item = Item;
List.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	className: PropTypes.string,
	variant: PropTypes.oneOf(["unordered", "ordered"]),
	listStyle: PropTypes.oneOf(["dotted", "arrowed", "buttons", "none"]),
};
List.defaultProps = {
	className: "",
	variant: "unordered",
	listStyle: "dotted",
};

export default List;
export { List };
